import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
// eslint-disable-next-line check-react-ssr-usage/no-static-and-loadable-export
export { isEligibleForProductRequirementsDiscovery } from '../src/rovo/ProductRequirementsDialog.tsx';
export const LazyProductRequirementsPublishDiscoveryDialog: LoadableType<{
	onClose: () => void;
	onCloseComplete: () => void;
	publishedPageTitle: string;
	spaceName: string;
	spaceKey?: string;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ProductRequirementsDialog" */ '../src/rovo/ProductRequirementsDialog.tsx'
			)
		).ProductRequirementsDialog,
});
